import React from "react";
import { _size, _sizeText } from "../../core/core";
import { Text } from "../texts/text";
import "./DropdownItem.css";

export interface IDropdownItemOption {
  key: string;
  label: string;
  src?: string;
  alt?: string;
}
interface DropdownItemProps {
  hover?: boolean;
  size?: _size;
  icon?: React.ReactNode;
  onClick?: () => void;
  nightMode?: "on" | "off";
  option: IDropdownItemOption;
}

export const DropdownItem: React.FC<DropdownItemProps> = ({
  hover = false,
  size = _size.M,
  icon,
  onClick,
  nightMode = "off",
  option,
  ...props
}) => {
  return (
    <button
      key={option.key}
      onClick={onClick}
      className={`dropdownItem dropdownItem-${size}`}
      {...props}
    >
      <div className="dropdown-master"></div>
      {option.src && (
        <img
          height="24"
          width="24"
          src={option.src}
          alt={option.alt || "dropdown item"}
        />
      )}
      {icon}
      <Text size={_sizeText.m}>{option.label}</Text>
    </button>
  );
};
